import styled, { css } from "styled-components";
import { memo } from "react";
import color from "../../../helpers/color";
import textSize from "../../../helpers/textSize";
import transparentize from "../../../helpers/transparentize";
export const sizes = {
  tiny: css(["height:auto;padding:7px 10px;line-height:16px;"]),
  small: css(["height:auto;padding:8px 10px;line-height:16px;"]),
  default: css(["height:42px;padding:0 15px;line-height:42px;"])
};
function size({
  size
}) {
  return sizes[size] || sizes.default;
}
const Input = /*#__PURE__*/memo(styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-5srigr-0"
})(["", " ", " flex:1;width:100%;border:none;border-radius:2px;background-color:", ";color:", ";transition:0.2s ease-in-out;transition-property:background-color,color;user-select:text;outline:none;&::placeholder{color:", ";}"], size, textSize, ({
  transparent
}) => transparent ? "transparent" : transparentize, color, color));
Input.defaultProps = {
  size: "default",
  color: "default",
  textSize: "default"
};
export default Input;
//# sourceMappingURL=Input.js.map